import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ChangeDetectorRef
} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { IconButtonDirective } from '@new/common/ui/icon-button.directive';
import { PoolSelectors } from '@new/pools/pool/state/pool/pool.selectors';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { TooltipModule } from 'primeng/tooltip';
import { Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

type PoolPage = 'questions' | 'tasks' | 'exams';

@Component({
  selector: 'man-pool-breadcrumb',
  templateUrl: './pool-breadcrumb.component.html',
  styleUrls: ['./pool-breadcrumb.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TooltipModule,
    OverlayPanelModule,
    TranslateModule,
    IconButtonDirective
  ]
})
export class PoolBreadcrumbComponent implements OnInit, OnDestroy {
  @ViewChild('pageMenu') public pageMenu: OverlayPanel;

  public poolName$: Observable<string | undefined>;
  public shouldShowBreadcrumb = false;
  public currentPage: PoolPage = 'questions';
  private poolId: string | undefined;
  private routerSubscription: Subscription;

  constructor(
    private store: Store,
    private router: Router,
    private changeDetection: ChangeDetectorRef
  ) {}

  public ngOnInit(): void {
    this.poolName$ = this.store.select(PoolSelectors.poolName);
    this.checkRoute();

    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.checkRoute();
        this.changeDetection.markForCheck();
      });
  }

  public ngOnDestroy(): void {
    if (this.routerSubscription !== undefined) {
      this.routerSubscription.unsubscribe();
    }
  }

  public navigateToPoolsList(): void {
    this.router.navigate(['/newpools']);
  }

  public navigateToPage(page: PoolPage): void {
    if (this.poolId !== undefined) {
      this.router.navigate(['/newpools', this.poolId, page]);
    }
    this.pageMenu.hide();
  }

  private checkRoute(): void {
    const url = this.router.url;
    const poolRouteMatch = url.match(/\/newpools\/(\d+)/);
    this.shouldShowBreadcrumb = poolRouteMatch !== null;

    if (poolRouteMatch !== null) {
      this.poolId = poolRouteMatch[1];
      this.currentPage = this.pageNameFromUrl(url);
    }
  }

  private pageNameFromUrl(url: string): PoolPage {
    if (url.includes('/exams')) {
      return 'exams';
    } else if (url.includes('/tasks')) {
      return 'tasks';
    } else {
      return 'questions';
    }
  }
}
